/**
 * Tailwind class merging for NativeWind components.
 *
 * @see docs/milestones/M0.6-UI-PRIMITIVES.md §3
 */

import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

// ─── Class Merger ──────────────────────────────────────────────────────────

/**
 * Merge Tailwind classes safely (handles conflicts like `p-2 p-4` → `p-4`).
 *
 * Combines `clsx` (conditional class joining) with `tailwind-merge`
 * (conflict resolution) into a single utility.
 *
 * @example
 * ```ts
 * cn('p-2 bg-coral', isActive && 'bg-purple', 'p-4')
 * // → 'bg-coral p-4'  (if isActive=false)
 * // → 'bg-purple p-4' (if isActive=true)
 * ```
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
